import { fmtNumber } from "../../lib/i18n";
export const fmt$ = (n) => `$${fmtNumber(n, { maximumFractionDigits: 2 })}`;
export const today = () => new Date().toISOString().slice(0, 10);
export const newLine = () => ({ _id: crypto.randomUUID(), sku: "", quantity: 1, unit_price: 0 });

export const STATUS_CLASS = {
  open: "bg-amber-50 text-amber-700",
  partial: "bg-sky-50 text-sky-700",
  received: "bg-emerald-50 text-emerald-700",
  fulfilled: "bg-emerald-50 text-emerald-700",
  cancelled: "bg-zinc-100 text-zinc-500 line-through",
};

export const inputCls = "bg-white px-3 py-3 text-sm outline-none";
export const cellInputCls = "border border-zinc-300 focus:border-zinc-950 px-2 py-1 text-sm outline-none w-full";
